import {
    CREATE_SIZE_MEASUREMENT_DETAILS_REQUEST,
    CREATE_SIZE_MEASUREMENT_DETAILS_SUCCESS,
    CREATE_SIZE_MEASUREMENT_DETAILS_FAILURE,
    DELETE_SIZE_MEASUREMENT_DETAILS_REQUEST,
    DELETE_SIZE_MEASUREMENT_DETAILS_SUCCESS,
    DELETE_SIZE_MEASUREMENT_DETAILS_FAILURE,
    FETCH_SINGLE_SIZE_MEASUREMENT_DETAILS_REQUEST,
    FETCH_SINGLE_SIZE_MEASUREMENT_DETAILS_SUCCESS,
    FETCH_SINGLE_SIZE_MEASUREMENT_DETAILS_FAILURE,
    FETCH_SIZE_MEASUREMENT_DETAILS_REQUEST,
    FETCH_SIZE_MEASUREMENT_DETAILS_SUCCESS,
    FETCH_SIZE_MEASUREMENT_DETAILS_FAILURE,
    UPDATE_SIZE_MEASUREMENT_DETAILS_REQUEST,
    UPDATE_SIZE_MEASUREMENT_DETAILS_SUCCESS,
    UPDATE_SIZE_MEASUREMENT_DETAILS_FAILURE,
    RESET_SIZE_MEASUREMENT_DETAILS_INFO,
    CREATE_SIZE_MEASUREMENT_DETAILS_FORM,
    UPDATE_SIZE_MEASUREMENT_DETAILS_FORM,
    COPY_FOR_ALL_SIZES_VAR,
    ALL_SIZES_LOADING,
    FETCH_PROPERTY_DATA_FOR_SIZE_DETAILS_MASTER_SUCCESS,
    FETCH_SIZE_MEASUREMENT_DETAILS_WITHOUT_ID_REQUEST,
    FETCH_SIZE_MEASUREMENT_DETAILS_WITHOUT_ID_SUCCESS,
    FETCH_SIZE_MEASUREMENT_DETAILS_WITHOUT_ID_FAILURE
} from './sizeMeasurementDetails.actionsType';

export const SIZE_MEASUREMENT_DETAILS = 'sizeMeasurementDetails';

let initialState = {
    loading: false,
    sizeMeasurementDetails: [],
    sizeMeasurementDetailsWithoutId: [],
    measurementDataFromProperty: [],
    partData: [],
    sizeMeasurementDetailsform: {},
    selectedState: {},
    errorMessage: '',
    copyForAllSizesVar: false,
    copyForAllDetailsForm: [],
    stylePreparationsItem: [],
    stylePreparationsDepartment: [],
    copyLoading: false
};

export let sizeMeasurementDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_SIZE_MEASUREMENT_DETAILS_REQUEST:
        case CREATE_SIZE_MEASUREMENT_DETAILS_REQUEST:
        case UPDATE_SIZE_MEASUREMENT_DETAILS_REQUEST:
        case FETCH_SINGLE_SIZE_MEASUREMENT_DETAILS_REQUEST:
        case FETCH_SIZE_MEASUREMENT_DETAILS_WITHOUT_ID_REQUEST:
        case DELETE_SIZE_MEASUREMENT_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_SIZE_MEASUREMENT_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                sizeMeasurementDetails: updatePayload
            };
        case FETCH_SIZE_MEASUREMENT_DETAILS_WITHOUT_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                sizeMeasurementDetailsWithoutId: updatePayload
            };
        case FETCH_PROPERTY_DATA_FOR_SIZE_DETAILS_MASTER_SUCCESS:
            if (payload == 22) {
                return {
                    ...state,
                    loading: false,
                    measurementDataFromProperty: updatePayload
                };
            } else if (payload == 21) {
                return {
                    ...state,
                    loading: false,
                    partData: updatePayload
                };
            } else if (payload == 54) {
                return {
                    ...state,
                    loading: false,
                    stylePreparationsDepartment: updatePayload
                };
            } else if (payload == 55) {
                return {
                    ...state,
                    loading: false,
                    stylePreparationsItem: updatePayload
                };
            } else {
                return {
                    ...state,
                    loading: false
                };
            }
        case CREATE_SIZE_MEASUREMENT_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                sizeMeasurementDetailsform: {}
            };
        case UPDATE_SIZE_MEASUREMENT_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                sizeMeasurementDetailsform: {}
            };
        case FETCH_SINGLE_SIZE_MEASUREMENT_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                sizeMeasurementDetailsform: updatePayload
            };
        case DELETE_SIZE_MEASUREMENT_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case COPY_FOR_ALL_SIZES_VAR:
            return {
                ...state,
                copyForAllSizesVar: payload
            };
        case RESET_SIZE_MEASUREMENT_DETAILS_INFO:
            return {
                ...state,
                sizeMeasurementDetailsform: {}
            };
        case CREATE_SIZE_MEASUREMENT_DETAILS_FORM:
        case UPDATE_SIZE_MEASUREMENT_DETAILS_FORM:
            return {
                ...state,
                loading: false,
                sizeMeasurementDetailsform: {
                    ...state.sizeMeasurementDetailsform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_SIZE_MEASUREMENT_DETAILS_FAILURE:
        case CREATE_SIZE_MEASUREMENT_DETAILS_FAILURE:
        case UPDATE_SIZE_MEASUREMENT_DETAILS_FAILURE:
        case FETCH_SINGLE_SIZE_MEASUREMENT_DETAILS_FAILURE:
        case DELETE_SIZE_MEASUREMENT_DETAILS_FAILURE:
        case FETCH_SIZE_MEASUREMENT_DETAILS_WITHOUT_ID_FAILURE:
            return {
                ...state,
                loading: false
            };
        case ALL_SIZES_LOADING:
            return {
                ...state,
                copyLoading: payload
            };
        default:
            return state;
    }
};
